module.exports = __webpack_public_path__ + "img/icon-income-light-blue.47053a64.svg";